"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAccordion = void 0;
var react_1 = __importStar(require("react"));
var react_accordion_1 = require("@radix-ui/react-accordion");
var styled_components_1 = __importStar(require("styled-components"));
var polished_1 = require("polished");
var icons_1 = require("../../icons");
var ChevronIcon = (0, styled_components_1.default)(icons_1.Chevron).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        primaryColor: theme.colors.border.primary,
        width: 16,
        height: 16,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: ", ";\n  flex-shrink: 0;\n"], ["\n  margin-right: ", ";\n  flex-shrink: 0;\n"])), (0, polished_1.rem)(16));
var StyledAccordionTrigger = (0, styled_components_1.default)(react_accordion_1.AccordionTrigger)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  border: none;\n  cursor: pointer;\n  background-color: ", ";\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-bottom: ", " solid ", ";\n\n  & > svg {\n    transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);\n  }\n"], ["\n  width: 100%;\n  border: none;\n  cursor: pointer;\n  background-color: ", ";\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-bottom: ", " solid ", ";\n\n  & > svg {\n    transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.secondary;
}, (0, polished_1.rem)(16), (0, polished_1.rem)(1), function (_a) {
    var theme = _a.theme;
    return theme.colors.border.secondary;
});
var StyledAccordionContainer = (0, styled_components_1.default)(react_accordion_1.Accordion)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: ", " solid ", ";\n  border-radius: ", ";\n\n  & > *:first-child > button {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n  }\n\n  & > div > button[data-state='open'] > svg {\n    transform: rotate(180deg);\n  }\n\n  & > *:last-child > button {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n\n  & > *:last-child > div {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n"], ["\n  border: ", " solid ", ";\n  border-radius: ", ";\n\n  & > *:first-child > button {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n  }\n\n  & > div > button[data-state='open'] > svg {\n    transform: rotate(180deg);\n  }\n\n  & > *:last-child > button {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n\n  & > *:last-child > div {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n"])), (0, polished_1.rem)(1), function (_a) {
    var theme = _a.theme;
    return theme.colors.border.secondary;
}, (0, polished_1.rem)(8), (0, polished_1.rem)(8), (0, polished_1.rem)(8), (0, polished_1.rem)(8), (0, polished_1.rem)(8), (0, polished_1.rem)(8), (0, polished_1.rem)(8));
// Define the keyframes for animations
var slideDown = (0, styled_components_1.keyframes)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  from {\n    max-height: 0;\n    opacity: 0;\n  }\n  to {\n    max-height: 100vh;\n    opacity: 1;\n  }\n"], ["\n  from {\n    max-height: 0;\n    opacity: 0;\n  }\n  to {\n    max-height: 100vh;\n    opacity: 1;\n  }\n"])));
var slideUp = (0, styled_components_1.keyframes)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  from {\n    max-height: 100vh;\n    opacity: 1;\n  }\n  to {\n    max-height: 0;\n    opacity: 0;\n  }\n"], ["\n  from {\n    max-height: 100vh;\n    opacity: 1;\n  }\n  to {\n    max-height: 0;\n    opacity: 0;\n  }\n"])));
// Conditionally apply animations based on data-state
var StyledAccordionContent = (0, styled_components_1.default)(react_accordion_1.AccordionContent)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n  overflow: hidden;\n\n  &[data-state='open'] {\n    animation: ", " 400ms cubic-bezier(0.87, 0, 0.13, 1);\n  }\n\n  &[data-state='closed'] {\n    animation: ", " 400ms cubic-bezier(0.87, 0, 0.13, 1);\n  }\n"], ["\n  background-color: ", ";\n  overflow: hidden;\n\n  &[data-state='open'] {\n    animation: ", " 400ms cubic-bezier(0.87, 0, 0.13, 1);\n  }\n\n  &[data-state='closed'] {\n    animation: ", " 400ms cubic-bezier(0.87, 0, 0.13, 1);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.primary;
}, slideDown, slideUp);
var StyledAccordion = function (_a) {
    var items = _a.items, defaultValue = _a.defaultValue, onOpenItem = _a.onOpenItem, props = __rest(_a, ["items", "defaultValue", "onOpenItem"]);
    var _b = (0, react_1.useState)(defaultValue || []), openItems = _b[0], setOpenItems = _b[1];
    var handleAccordionChange = function (values) {
        var newlyOpenedAccordionItem = values.filter(function (item) { return !openItems.includes(item); })[0];
        if (onOpenItem && newlyOpenedAccordionItem) {
            onOpenItem(newlyOpenedAccordionItem);
        }
        setOpenItems(values);
    };
    return (react_1.default.createElement(StyledAccordionContainer, __assign({ type: "multiple", defaultValue: defaultValue }, props, { onValueChange: handleAccordionChange }), items.map(function (item, index) { return (react_1.default.createElement(react_accordion_1.AccordionItem, { key: index, value: item.value ? item.value : "item-".concat(index) },
        react_1.default.createElement(StyledAccordionTrigger, null,
            react_1.default.createElement(ChevronIcon, null),
            react_1.default.createElement("span", null, item.header)),
        react_1.default.createElement(StyledAccordionContent, null, item.content))); })));
};
exports.StyledAccordion = StyledAccordion;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
